<div class="mat-chip-list-wrapper"><ng-content></ng-content></div>